import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    phone: '111111'
  },
  mutations: {
    // 设置手机号码
    setPhone (state, newPhone) {
      state.phone = newPhone;
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/store.js